module.exports = __webpack_public_path__ + "img/bridge.081d1f41.jpeg";